import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"

const PrimarySelect = ({ label, options, selected, setSelected }) => {
    return (
        <FormControl fullWidth sx={{
        }}>
            <InputLabel id={"label_id"} sx={{
                fontFamily: "Poppins",
            }}>
                {label}
            </InputLabel>
            <Select sx={{
                fontFamily: "Poppins", height: "40px"
            }} labelId="label_id" label={label} placeholder={label} value={selected} onChange={(e) => { setSelected(e.target.value) }}>
                {options.map((o, index) => {
                    return (
                        <MenuItem value={o.value} key={index} sx={{ fontFamily: "Poppins" }}>{o.label}</MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
}

export default PrimarySelect